/**
 * Botón "Cómo llegar" del técnico (Bloque 1 ubicación): construye el link de
 * navegación de Google Maps. PURO. Prioridad:
 *   1. Link de Maps de la ficha de despacho (lo que mandó el cliente, tal cual).
 *   2. Coordenadas objetivo del trabajo (navegación directa).
 *   3. Búsqueda por el texto de la dirección (+ zona si hay).
 * Sin ninguna de las tres → null (el botón no se pinta).
 */
export function buildMapsHref(job: {
  despachoJson?: { mapsUrl?: string | null } | null;
  targetLat?: number | null;
  targetLng?: number | null;
  direccion?: string | null;
  zona?: string | null;
}): string | null {
  const mapsUrl = job.despachoJson?.mapsUrl?.trim();
  if (mapsUrl) return mapsUrl;

  if (job.targetLat != null && job.targetLng != null) {
    const destination = encodeURIComponent(`${job.targetLat},${job.targetLng}`);
    return `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
  }

  const direccion = job.direccion?.trim();
  if (direccion) {
    const query = [direccion, job.zona?.trim()].filter(Boolean).join(', ');
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;
  }

  return null;
}
